<template>
  <Card
    :class="$style.position"
    :data-test-id="`wayToAddSystemUser__${wayToAddSystemUser.id}`"
  >
    <img
      :class="$style.icon"
      data-test-id="wayToAddSystemUser__icon"
      :src="wayToAddSystemUser.icon"
      svg-inline
    >
    <div>
      <h4
        :class="$style.title"
        data-test-id="wayToAddSystemUser__title"
      >
        {{ wayToAddSystemUser.title }}
      </h4>

      <div :class="$style.spacing">
        <FlatActionButton
          :action="redirect"
          :buttonClass="['btnDefault']"
          :text="wayToAddSystemUser.external ? 'learn more' : 'add users'"
        />

        <div
          v-if="wayToAddSystemUser.expandedCopy"
          :class="$style.spacing"
        >
          <em
            :class="$style.spacing"
            data-test-id="wayToAddSystemUser__copy"
          >
            {{ wayToAddSystemUser.expandedCopy }}
          </em>
        </div>
        <div
          v-if="wayToAddSystemUser.learnMoreLinks && wayToAddSystemUser.learnMoreLinks.length"
        >
          <BDropdownDivider />
          <div :class="$style.spacing">
            <ul :class="$style.learnMoreList">
              <li
                v-for="(learnMoreBullet, index) in wayToAddSystemUser.learnMoreLinks"
                :key="index"
              >
                <ExternalLink
                  :href="learnMoreBullet.href"
                  :showExternalLinkIcon="false"
                  :text="learnMoreBullet.text"
                  @click="handleLearnMoreResourceClicked(learnMoreBullet.text)"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </Card>
</template>

<script>
import {
  BDropdownDivider,
} from 'bootstrap-vue';
import { eventLocations, eventProperties } from 'client/GrowthEngineering/utilities/GrowthConstants';
import Card from 'client/components/Card.vue';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import ExternalLink from 'components/ExternalLink.vue';
import FlatActionButton from 'client/components/Buttons/FlatActionButton.vue';
import ImportFromCSVModalHelper from 'client/systemusers/ImportUsers/ImportFromCSVModalHelper';
import Util from 'client/util/Util';

const {
  description,
  location,
  section,
  text,
} = eventProperties;

export default {
  name: 'WayToAddSystemUserCard',

  components: {
    BDropdownDivider,
    Card,
    ExternalLink,
    FlatActionButton,
  },

  EventHelper,
  ImportFromCSVModalHelper,
  Util,

  props: {
    wayToAddSystemUser: {
      default: null,
      type: Object,
    },
  },

  methods: {
    handleLearnMoreResourceClicked(moreLearnBullet) {
      this.$options.EventHelper.triggerWaysToAddSystemUserLearnMoreClicked({
        resource: moreLearnBullet,
        card: this.wayToAddSystemUser.title,
      });
    },

    async redirect() {
      if (!this.wayToAddSystemUser.redirectUrl) {
        return this.showCsvImportModal();
      }

      let redirectUrl;
      if (typeof this.wayToAddSystemUser.redirectUrl === 'function') {
        redirectUrl = await this.wayToAddSystemUser.redirectUrl();
      } else {
        ({ redirectUrl } = this.wayToAddSystemUser);
      }

      if (this.wayToAddSystemUser.external) {
        return this.$options.Util.openUrl(redirectUrl);
      }
      return this.$options.Util.redirect(redirectUrl);
    },

    showCsvImportModal() {
      this.$options.EventHelper.triggerModalViewed({
        [description]: 'Open Import from CSV Modal',
        [location]: eventLocations.usersPage,
        [section]: 'Add your first user',
        [text]: 'Import from CSV',
      });

      this.$options.ImportFromCSVModalHelper.showImportFromCSVModal();
    },
  },
};
</script>

<style module>
@import './waysToAddSystemUserCards.css';
</style>
